export default __webpack_public_path__ + "static/media/ic-irr-k-lines.4c1ea674.svg";